import { useQuery } from "@tanstack/react-query";

import { getNewArticles, getNewNews, getRecommendedArticles } from "services";

import { queryIsLoading } from "utils";

import { ArticleCard } from "models";

export type CARD_TYPE = "ARTICLE" | "NEWS";

interface TypedNewsArticleCard extends ArticleCard {
  type: CARD_TYPE;
}

const addType =
  (type: CARD_TYPE) =>
  (card: ArticleCard): TypedNewsArticleCard => ({
    ...card,
    type,
  });

export const useGetNewsAndArticles = () => {
  const recommendedArticlesQuery = useQuery({
    queryKey: ["recommendedArticles"],
    queryFn: () => getRecommendedArticles(),
  });

  const newNewsQuery = useQuery({
    queryKey: ["newNews"],
    queryFn: () => getNewNews(),
  });

  const newArticlesQuery = useQuery({
    queryKey: ["newArticles"],
    queryFn: () => getNewArticles(),
  });

  const isLoading = [recommendedArticlesQuery, newNewsQuery, newArticlesQuery].some(queryIsLoading);

  return {
    isLoading,
    newNews: newNewsQuery.data?.map(addType("NEWS")),
    newArticles: newArticlesQuery.data?.map(addType("ARTICLE")),
    recommendedArticles: recommendedArticlesQuery.data?.map(addType("ARTICLE")),
  };
};
